// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".App__App___3o5IP{display:flex;flex-direction:row;height:100%;width:100%}.spectrum--light .App__App___3o5IP{--docViewBgColorBeforeFileLoad:var(--spectrum-global-color-gray-50);--docViewBgColorAfterFileLoad:var(--spectrum-global-color-gray-100);--iconFill:var(--spectrum-global-color-gray-800)}.spectrum--dark .App__App___3o5IP{--docViewBgColorBeforeFileLoad:var(--spectrum-global-color-gray-100);--docViewBgColorAfterFileLoad:var(--spectrum-global-color-gray-50);--iconFill:var(--spectrum-global-color-gray-700)}", ""]);
// Exports
exports.locals = {
	"App": "App__App___3o5IP"
};
module.exports = exports;
